import React from 'react';
/**
 * Shop All Products page breadcrumb trail.
 */
export function Breadcrumb() {
  return <nav className="text-sm text-gray-500 mb-4" aria-label="Breadcrumb" data-id="element-793">
      <a href="/" className="hover:text-gray-900" data-id="element-794">
        Home
      </a>
      <span className="mx-2" data-id="element-795">/</span>
      <span className="text-gray-900 font-medium" data-id="element-796">Shop All Products</span>
    </nav>;
}